<template>
  <div class="flex flex-center">
    <div class="text-center text-purple-9">
      <q-spinner color="purple-9" size="xl" class="q-mb-lg" />
    </div>
  </div>
</template>

<script lang="ts" setup>
</script>

<style scoped>
.flex {
  height: 100vh;
}
</style>
